import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_DISTRICT, UPDATE_DISTRICT, LANGUAGES_SEARCH, CITIES_SEARCH } from "helpers/api_endpoints";
import MapComponent from "../../components/Common/Map"
import Select from "react-select";



//meta title
document.title = "Edit District";

const EditDistrict = () => {
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setName] = useState('');
    const [cities, setCities] = useState([]);
    const [cityId, setCityId] = useState('');
    const [symbol, setSymbol] = useState('');
    const [status, setStatus] = useState(0);
    const [changed, setChanged] = useState(false);
    const [fPoints, setFPoints] = useState([{ lat: 0, lng: 0 },{ lat: 0, lng: 0 }, { lat: 0, lng: 0 }, { lat: 0, lng: 0 }]);
    const [boundries, setBoundries] = useState([[
        { lat: 24.712186535213522, lng: 55.11976906855254 },
        { lat: 24.712186535213522, lng: 55.23976906855254 },
        { lat: 24.882186535213522, lng: 55.23976906855254 },
        { lat: 24.882186535213522, lng: 55.11976906855254 }
        ]]);
    const [valued, setValued] = useState({"title":[]});
    const [languages, setLanguages] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        get(`${SHOW_DISTRICT}/${params.id}`)
            .then(response => {
                const district = response.data;
                setid(params.id);
                setCityId(district.cityId);
                setSymbol(district.symbol);
                if(district.boundries != '')
                {
                    if(JSON.parse(district.boundries))
                    {
                        setFPoints(JSON.parse(district.boundries)[0]);
                        setBoundries(JSON.parse(district.boundries)); 
                        setChanged(!changed);
                    }
                }
                setName(district.name);
                setValued(district.named);
                setName(JSON.stringify(district.named));
                setStatus(district.status);
                setLoading(false);
            })
            .catch(error => {console.log(error)
                // navigate('/cities');
            })
    }, []);

    useEffect(() => {
        post(`${CITIES_SEARCH}`)
            .then(response => {
                const data = response.data.map((el,index)=>{
                    return {value: el.id,label: el.name}; 
                });
                setCities(data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
                console.log(error)
                // if (error.response.status == 400) {
                //     navigate('/logout');
                // }
            })
    }, []);

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    useEffect(() => {
        setFPoints(boundries[0]);
        console.log('boundries--',boundries);
    }, [boundries]);

    const handleSubmit = () => {
        const b = JSON.stringify(boundries);
        put(UPDATE_DISTRICT, { id, name, cityId: cityId, symbol, status, boundries: b })
            .then(response => {
                if (response.code == 200) {
                    navigate('/districts', { state: { successMsg: 'District Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleName = (languageId,value) => {
        if(!valued?.title)
            setValued({"title":[]});
        const ln = valued?.title?.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued?.title?.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }
	const handleFilter = (type,value) => {
		switch(type)
		{
			case 'cityId':
				{
					setCityId(value);
					break;
				}
            case 'name':
                {
                    break;
                }
			default:
				break;
		}

	}

    const setFPointsVal = (index, type, value) => {
        if(!boundries[0])
            return;
        const points = [...boundries[0]];
        if(type == 0)
            points[index].lat = Number(value);
        else if(type == 1)
            points[index].lng = Number(value);
        setBoundries([points]);
    }

    return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs title="Cities" breadcrumbItem="Edit District" />
					<Form
						className="form-horizontal"
						onSubmit={(e) => {
							e.preventDefault();
							handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										<Row>
											{errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
											{
												languages.map((language, index) => (
													<Row key={index}>
													<div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
												</Row>
                                                ))
											}
											
											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>City</Trans></Label>
												<Select
													name="cityId"
													value={cities?.find(el => el.value==cityId)}
													options={cities} 
													className="form-control select2"
													onChange={(e) => handleFilter('cityId', e.value)}
                                                    required
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Symbol</Trans></Label>
												<Input
													name="symbol"
													value={symbol}
													className="form-control"
													placeholder="Enter Symbol"
													type="text"
													onChange={(e) => setSymbol(e.target.value)} 
                                                    required
												></Input>
											</div>


											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Status</Trans></Label>
												<select className="form-control" onChange={(e) => setStatus(e.target.value)} required>
													<option value=''></option>
													<option value={1} selected={status == 1}><Trans>Active</Trans></option>
													<option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
												</select>
											</div>

										</Row>
										<div className="text-center  mt-4">
											<Button type="submit" color="danger">
												<Trans>Submit</Trans>
											</Button>
										</div>
									</CardBody>
									<CardBody>
										<Row>
											<div className="form-group col-md-3 mt-2 py-2  pb-3 bg-light">
                                                <Label className="form-label"><Trans>Point 1</Trans></Label>
										        <Row>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Latitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[0]?.lat:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(0, 0, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Longitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[0]?.lng:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(0, 1, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
                                                </Row>
											</div>
											<div className="form-group col-md-3 mt-2 py-2 pb-3">
                                                <Label className="form-label"><Trans>Point 2</Trans></Label>
										        <Row>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Latitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[1]?.lat:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(1, 0, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Longitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[1]?.lng:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(1, 1, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
                                                </Row>
											</div>
											<div className="form-group col-md-3 mt-2 py-2 pb-3 bg-light">
                                                <Label className="form-label"><Trans>Point 3</Trans></Label>
										        <Row>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Latitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[2]?.lat:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(2, 0, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Longitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[2]?.lng:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(2, 1, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
                                                </Row>
											</div>
											<div className="form-group col-md-3 mt-2 py-2 pb-3">
                                                <Label className="form-label"><Trans>Point 4</Trans></Label>
										        <Row>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Latitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[3]?.lat:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(3, 0, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
											        <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Longitude</Trans></Label>
                                                        <Input
                                                            name="fPoints"
                                                            value={fPoints?fPoints[3]?.lng:0}
                                                            className="form-control"
                                                            placeholder="Enter "
                                                            type="text"
                                                            onChange={(e) => setFPointsVal(3, 1, e.target.value)} 
                                                            required
                                                        ></Input>
                                                    </div>
                                                </Row>
											</div>
                                            {/* <div className="text-center  mt-4">
                                                <Button type="button" color="primary">
                                                    <Trans>Set Points</Trans>
                                                </Button>
                                            </div> */}
                                        </Row>
										<Row>

											<div className="form-group col-md-12 mt-2" >
												<Label className="form-label"><Trans>Map</Trans></Label>
												<MapComponent key={changed} setChanged={setChanged} changed={changed} boundries={boundries} setBoundries={setBoundries} />
											</div>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col xl={12}>
								<Row>

								</Row>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
    )
}

export default EditDistrict
